import { render, staticRenderFns } from "./vue3dLoader.vue?vue&type=template&id=f75d4aac&"
import script from "./vue3dLoader.vue?vue&type=script&lang=js&"
export * from "./vue3dLoader.vue?vue&type=script&lang=js&"
import style0 from "./vue3dLoader.vue?vue&type=style&index=0&id=f75d4aac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports